"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomContextData = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var CustomContextData = /*#__PURE__*/function () {
  function CustomContextData() {
    (0, _classCallCheck2["default"])(this, CustomContextData);
  }

  (0, _createClass2["default"])(CustomContextData, null, [{
    key: "sort",
    value: // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function sort(customContextData) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var tempArr = new Array();
      Object.keys(customContextData).forEach(function (key) {
        if (customContextData && customContextData["".concat(key)]) {
          var obj = {
            "key": key,
            "value": customContextData["".concat(key)]
          };
          tempArr.push(obj);
        }
      }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

      tempArr.sort(function (a, b) {
        var keyA = a.key.toUpperCase(); // ignore upper and lowercase

        var keyB = b.key.toUpperCase(); // ignore upper and lowercase

        if (keyA < keyB) {
          return -1;
        }

        if (keyA > keyB) {
          return 1;
        }

        return 0;
      });
      return tempArr;
    }
  }]);
  return CustomContextData;
}();

exports.CustomContextData = CustomContextData;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9DdXN0b21Db250ZXh0RGF0YS50cyJdLCJuYW1lcyI6WyJDdXN0b21Db250ZXh0RGF0YSIsImN1c3RvbUNvbnRleHREYXRhIiwidGVtcEFyciIsIkFycmF5IiwiT2JqZWN0Iiwia2V5cyIsImZvckVhY2giLCJrZXkiLCJvYmoiLCJwdXNoIiwic29ydCIsImEiLCJiIiwia2V5QSIsInRvVXBwZXJDYXNlIiwia2V5QiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztJQUFhQSxpQjs7Ozs7OztXQUNYO0FBQ0Esa0JBQW1CQyxpQkFBbkIsRUFBb0U7QUFDbEU7QUFDQSxVQUFNQyxPQUFPLEdBQUcsSUFBSUMsS0FBSixFQUFoQjtBQUVFQyxNQUFBQSxNQUFNLENBQUNDLElBQVAsQ0FBWUosaUJBQVosRUFBK0JLLE9BQS9CLENBQXVDLFVBQUFDLEdBQUcsRUFBSTtBQUM1QyxZQUFJTixpQkFBaUIsSUFBSUEsaUJBQWlCLFdBQUlNLEdBQUosRUFBMUMsRUFBc0Q7QUFDbEQsY0FBTUMsR0FBRyxHQUFHO0FBQUMsbUJBQU9ELEdBQVI7QUFBYSxxQkFBU04saUJBQWlCLFdBQUlNLEdBQUo7QUFBdkMsV0FBWjtBQUNBTCxVQUFBQSxPQUFPLENBQUNPLElBQVIsQ0FBYUQsR0FBYjtBQUNIO0FBQ0YsT0FMRCxFQUpnRSxDQVdoRTs7QUFDQU4sTUFBQUEsT0FBTyxDQUFDUSxJQUFSLENBQWEsVUFBQ0MsQ0FBRCxFQUFTQyxDQUFULEVBQW9CO0FBQy9CLFlBQU1DLElBQUksR0FBR0YsQ0FBQyxDQUFDSixHQUFGLENBQU1PLFdBQU4sRUFBYixDQUQrQixDQUNHOztBQUNsQyxZQUFNQyxJQUFJLEdBQUdILENBQUMsQ0FBQ0wsR0FBRixDQUFNTyxXQUFOLEVBQWIsQ0FGK0IsQ0FFRzs7QUFDbEMsWUFBSUQsSUFBSSxHQUFHRSxJQUFYLEVBQWlCO0FBQ2YsaUJBQU8sQ0FBQyxDQUFSO0FBQ0Q7O0FBQ0QsWUFBSUYsSUFBSSxHQUFHRSxJQUFYLEVBQWlCO0FBQ2YsaUJBQU8sQ0FBUDtBQUNEOztBQUNELGVBQU8sQ0FBUDtBQUNELE9BVkQ7QUFXRixhQUFPYixPQUFQO0FBQ0QiLCJzb3VyY2VSb290Ijoib2NzZGs6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIEN1c3RvbUNvbnRleHREYXRhIHtcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnlcbiAgcHVibGljIHN0YXRpYyBzb3J0KGN1c3RvbUNvbnRleHREYXRhOiB7IFtrZXk6IHN0cmluZ106IGFueSB9KSA6IGFueSB7XG4gICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnlcbiAgICBjb25zdCB0ZW1wQXJyID0gbmV3IEFycmF5PGFueT4oKTtcblxuICAgICAgT2JqZWN0LmtleXMoY3VzdG9tQ29udGV4dERhdGEpLmZvckVhY2goa2V5ID0+IHtcbiAgICAgICAgaWYgKGN1c3RvbUNvbnRleHREYXRhICYmIGN1c3RvbUNvbnRleHREYXRhW2Ake2tleX1gXSkge1xuICAgICAgICAgICAgY29uc3Qgb2JqID0ge1wia2V5XCI6IGtleSwgXCJ2YWx1ZVwiOiBjdXN0b21Db250ZXh0RGF0YVtgJHtrZXl9YF19O1xuICAgICAgICAgICAgdGVtcEFyci5wdXNoKG9iaik7XG4gICAgICAgIH1cbiAgICAgIH0pO1xuXG4gICAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLWV4cGxpY2l0LWFueVxuICAgICAgdGVtcEFyci5zb3J0KChhOiBhbnksIGI6IGFueSkgPT4ge1xuICAgICAgICBjb25zdCBrZXlBID0gYS5rZXkudG9VcHBlckNhc2UoKTsgLy8gaWdub3JlIHVwcGVyIGFuZCBsb3dlcmNhc2VcbiAgICAgICAgY29uc3Qga2V5QiA9IGIua2V5LnRvVXBwZXJDYXNlKCk7IC8vIGlnbm9yZSB1cHBlciBhbmQgbG93ZXJjYXNlXG4gICAgICAgIGlmIChrZXlBIDwga2V5Qikge1xuICAgICAgICAgIHJldHVybiAtMTtcbiAgICAgICAgfVxuICAgICAgICBpZiAoa2V5QSA+IGtleUIpIHtcbiAgICAgICAgICByZXR1cm4gMTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gMDtcbiAgICAgIH0pO1xuICAgIHJldHVybiB0ZW1wQXJyO1xuICB9XG59XG5cblxuIl19